import { render, staticRenderFns } from "./SmartAddress.vue?vue&type=template&id=1d1a16c5&scoped=true"
import script from "./SmartAddress.vue?vue&type=script&lang=js"
export * from "./SmartAddress.vue?vue&type=script&lang=js"
import style0 from "./SmartAddress.vue?vue&type=style&index=0&id=1d1a16c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a16c5",
  null
  
)

export default component.exports